import b from 'b_';
import cx from 'classnames';
import { Text } from 'platform-components';
import {
    withRouterPath,
    InjectedProps as WithRouterPathProps,
} from 'platform-components/src/utils/hocs/with-router-path/with-router-path';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { Action, bindActionCreators, Dispatch } from 'redux';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { LESSON_MODAL_TABS } from 'common.components/lesson-view.store/typings';
import * as lessonSelectors from 'common.components/lesson/selectors';

import './lesson-view__tabs.scss';

interface StoreProps {
    selectedTab: LESSON_MODAL_TABS | null;
    clessonId: number | null;
}

interface DispatchProps {
    setSelectedTab: typeof lessonViewActions.setSelectedTab;
}

interface Props extends StoreProps, DispatchProps, WithRouterPathProps {}

export const LessonViewTabs = (props: Props) => {
    const { selectedTab, setSelectedTab, match, clessonId } = props;
    const subject = match?.params?.subject;

    const handleClickStats = () => {
        setSelectedTab(LESSON_MODAL_TABS.STATS);

        ym('reachGoal', 'urlClessonResults', {
            subject,
            type: 'in-lesson',
            content: 'results',
            clessonId,
        });
    };

    const handleClickProblems = () => {
        setSelectedTab(LESSON_MODAL_TABS.PROBLEMS);

        ym('reachGoal', 'urlClessonResults', {
            subject,
            type: 'in-lesson',
            content: 'сards',
            clessonId,
        });
    };

    return (
        <div className="lesson-view__tabs-wrapper">
            <div className="lesson-view__tabs">
                <div
                    className={cx(
                        b('lesson-view', 'tabs-item', { selected: selectedTab === LESSON_MODAL_TABS.STATS }),
                        'qa_lesson-modal-tab-stats'
                    )}
                    {...accessibleClick(handleClickStats)}
                >
                    <Text id="lessonView.tabs.stats" weight={Text.WEIGHT.M} />
                </div>
                <div
                    className={cx(
                        b('lesson-view', 'tabs-item', { selected: selectedTab === LESSON_MODAL_TABS.PROBLEMS }),
                        'qa_lesson-modal-tab-problems'
                    )}
                    {...accessibleClick(handleClickProblems)}
                >
                    <Text id="lessonView.tabs.problems" weight={Text.WEIGHT.M} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    return {
        selectedTab: lessonViewSelectors.getSelectedTab(storeState),
        clessonId: lessonSelectors.getCLessonId(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            setSelectedTab: lessonViewActions.setSelectedTab,
        },
        dispatch
    );
};

const wrapped = withRouterPath(connect(mapStateToProps, mapDispatchToProps)(LessonViewTabs));

wrapped.displayName = 'LessonViewTabs';

export default wrapped;
